import axios from 'axios'
import md5 from 'md5'
import wx from 'weixin-js-sdk'

function handleInfo (info) {
  let shareInfo = info || {}
  return {
    title: shareInfo.title   || document.title,
    desc: shareInfo.desc     || '核心优质职位，用心为你规划更好的“钱”途',
    link: shareInfo.link     || window.location.href,
    imgUrl: shareInfo.imgUrl || 'https://www.aiimooc.com/skin/200061/img/wx-share.jpg'
  }
}

function getWxData () {
  const promise = new Promise( (resolve, reject) => {
    axios.get('https://www.aiimooc.com/api/ajax.php', {
      params: {
        action: 'college',
        step: 'wxshare',
        encrypt: md5(new Date()),
        fromurl: window.location.href
      }
    }).then( res => {
      res = res.data
      if (res.status) {
        resolve(res.wxdata)
      }
    })
  })
  return promise
}

async function setWxShare (info) {
  const shareInfo = handleInfo(info)
  let confInfo = {
    debug: false,
    appId: '',
    nonceStr: '',
    timestamp: '',
    signature: '',
    jsApiList:['updateAppMessageShareData', 'updateTimelineShareData']
  }
  const wxData = await getWxData()
  Object.assign(confInfo, wxData)

  wx.config(confInfo)
  wx.ready(function() {
    wx.updateAppMessageShareData(shareInfo)
    wx.updateTimelineShareData(shareInfo)
  })
}

export default setWxShare
